<template>
  <div class="PopularNews" >
    <div class="PopularNews-title">热门资讯</div>
    <div class="PopularNews-content" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0)">
      <div class="PopularNews-content-list"  v-for="(li,index)  in list.slice(0, pageSize)" :key="li.id" >
        <!--        <img class="list-topping keep-hue" :src="require('@/assets/Home/Index/NewsIndex/newTop.png')" v-if="li.topStatus === '1'">-->
        <div class="PopularNews-content-list-title twoRowEllipsis" @click="goToNewsDetail(li,index)" :class="li.read=== '1' ? 'readed-active' : ''">{{li.title}}</div>
      </div>
      <div v-if="list.length === 0 && !loading">
        <NoData/>
      </div>
    </div>

  </div>
</template>
<script>
  import req from "portal-component/src/utils/request";
  import { getHotCms,writeReadRecord } from "@/api/news.js";
  import NoData from './noData.vue';
  import {mapGetters} from "vuex";
  export default {
    name: "PopularNews",
    props: {
      serveUrl: { type: String, required: true },
      request: { type: Function, default: req },
      openApi: { type: Boolean, default: false },
      pageNo: { type: Number, default: 1 },
      pageSize: { type: Number, default: 10 },
      columnId: { type: String, default: '' }
    },
    data() {
      return {
        list: [],
        loading: false
      };
    },
    created() {
      this.handHotNews();
    },
    watch: {
      columnId(val) {
        this.handHotNews();
      }
    },
    components: {
      NoData
    },
    methods: {
      goToNewsDetail(newsItem,index){
        // 点击设置已读状态
        if(this.list[index].read !== '1') this.$set(this.list[index],'read','1');
        this.writeReadRecord(newsItem);
        if(newsItem.url) {
          window.open(newsItem.url)
          return false;
        }
        let a = this.$router.resolve({ name: "NewsDetail", query: { id: newsItem.id } })
        window.open(a.href)
      },
      // 记录资讯查看
      writeReadRecord(newsItem) {
        let data = {contentId:newsItem.id, request: this.request,
          serveUrl: this.serveUrl,
          header: "portal"}
        writeReadRecord(data);
      },
      async handHotNews() {
        let data = {
          request: this.request,
          serveUrl: this.serveUrl,
          header: this.openApi ? "open" : "portal",
          params: {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            columnId: this.columnId || ''
          }

        };
        this.loading = true;
        this.list=[];
        try{
          let res = await getHotCms(data);
          this.loading = false;
          if(res.code !==0 ) {
            // this.$message.error('获取热门资讯错误！');
            return false;
          }
          this.list = res.data || [];
        }catch(e) {
        }
        this.loading = false;
      }
    },
  };
</script>
<style scoped lang="scss">
  @import "@/styles/variables.scss";
  .PopularNews {
    width: 100%;
    color: #333333;
    background-color: white;
    border-radius: 6px;
    padding: 30px;
    box-shadow:0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    &-title{
      font-size: 24px;
      font-weight: 500;
      line-height: 34px;
      padding-bottom: 30px;
      text-align: center;
      border-bottom:1px solid #E6E6E6;
    }
    &-content {
      min-height: 540px;
      &-list{
        width: 100%;
        font-size: 16px;
        cursor: pointer;
        margin-top: 30px;
        &-title{
          line-height: 24px;
          max-width: 100%;
          transition: 0.4s;
          font-weight: 400;
          color: #333333;
          &.readed-active {
            color: #666666;
          }
          &:hover {
           color: $color-primary;
          }
        }
      }
    }


  }

</style>